





































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import { RadioDoubleLine } from '@/interfaces/radio-double-line'

@Component({
})
export default class AppRadio extends Vue {
  @Prop() readonly value!: number
  @Prop() readonly options!: string[] | RadioDoubleLine[]
  @Prop({ default: false }) readonly disabled!: boolean
  @Prop() readonly type!: string
  @Prop({ default: 2 }) readonly columns!: number

  activeIndex = 0

  mounted () {
    this.activeIndex = this.value
  }

  @Watch('value')
  onValueChanged (val: number) {
    this.activeIndex = val
  }

  @Emit('input')
  switchValue (index: number) {
    this.activeIndex = index
    return index
  }

  slot (index: number) {
    return 'option_' + index
  }
}
